import { useRoutes } from 'react-router-dom';
import menuList from './menu';
export default function
    ListOfRoutes() {
    const list: any = menuList.map((value) => ({ path: value.path, element: value.element, children: value?.children || [] }))
    const element = useRoutes(list)
    return element;
}


